import * as actionTypes from './actionTypes';

interface State {
  data: any;
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: {},
  isFetching: false,
  error: false
}

export const announcementDetail = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_ANNOUNCEMENT_DETAIL_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_ANNOUNCEMENT_DETAIL_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_ANNOUNCEMENT_DETAIL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    default:
      return state;
  }
}
